import React from 'react';

const SelectDropdown = React.createClass({

  render: function() {
  	let data = this._getList(this.props.items);
    return (
    	<div className={this.props.className}>
        <h2>{data.selected.name}</h2>
        <ul>
          {data.unselected}
        </ul>
    	</div>
    );
  },

  _getList: function(items) {
    let selected = {};
    let unselected = [];
    for(let i=0; i < items.length; i++) {
      if(items[i].selected) {
        selected = items[i];
      }
      else {
        unselected.push(
          <li key={i}>{items[i].name}</li>
        );
      }
    }
    return {
    	selected: selected,
    	unselected: unselected,
    }
  }

});

export default SelectDropdown;



/** WEBPACK FOOTER **
 ** ./src/js/components/common/select_dropdown.js
 **/